import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";
import { Grid } from '@mui/material';

function MobileAddEvent() {
  const navigate = useNavigate();
  const initialValues = {
    Event_Title: "",
    Event_Venue: "",
    Description: "",
  };

  const validationSchema = Yup.object({
    Event_Title: Yup.string().required("Required"),
    Event_Venue: Yup.string().required("Required"),
    Description: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);
  return (
    <div className='mainwrapperView'>
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/UpcomingEvents")}
        />
        <h1>Add Event</h1>
    </div>
    <div className='topSpace'></div>
    <div className='mainWrapperListView'>
      <div className="famDetailsListInrMob">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
        <Form>
      <div className='FormView'>
          <Grid item xs={12} md={12}>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Event Title"
              placeholder="Enter Title"
              labelclassName="inputLebal"
              name="Event_Title"
              className="titleInput"
            />
            </div>
          </Grid> 
          <Grid item xs={12} md={12}>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Event Venue"
              placeholder="Enter Venue"
              labelclassName="inputLebal"
              name="Event_Venue"
              className="titleInput"
            />
            </div>
          </Grid> 
          <div className='DateTimeOuterView'>
            <div className='DateTimeView'>
            <p className='inputLebal'>Select Start Date</p>
            <input type='date' value="2024-07-12"  className='datetimeinputPolls'/>
            </div>
            <div className='DateTimeView'>
            <p className='inputLebal'>Select Start Time</p>
            <input type='time' value="19:30" className='datetimeinputPolls'/>
            </div>
          </div>
          <div className='DateTimeOuterView'>
          <div className='DateTimeView'>
            <p className='inputLebal'>Select End Date</p>
            <input type='date' value="2024-07-12"  className='datetimeinputPolls'/>          
          </div>
          <div className='DateTimeView'>
            <p className='inputLebal'>Select End Time</p>
            <input type='time' value="19:30" className='datetimeinputPolls'/>
          </div>
          </div>
            <div className='radioBtnTxtView margineTopAdd'>
            <div className="famDetailsListTo">
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>All Member</p>
            </div>
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>Owner's</p>
            </div>
            </div>
            <div className="famDetailsListTo">
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>Committee Member's</p>
            </div>
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>Group's</p>
            </div>
            </div>
            </div>
            <Grid item xs={12} md={12}>
            <div className='lebalInputView'>
            <FormikControl
              control="textarea"
              type="text"
              label="Description"
              placeholder="Enter Description"
              labelclassName="inputLebal"
              name="Description"
              className="textAreaInput"
            />
            </div>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className='checkBoxView widthFifty'>
              <input className='checkBoxStyle' type='checkbox' />
              <p className='checkBoxTxt'>Allow RSVP</p>
            </div>
          </Grid>
            <button className='submitButton' type='submit'>Submit</button>
      </div>
      </Form>
        )}
      </Formik>
      </div>
    </div>
    </div>
  )
}

export default MobileAddEvent